/**
* Do not edit directly
* This file is auto-generated
*/

export const dynamicallyImportIcon = iconName => {
  switch (iconName) {
    case 'ada':
      return import('@homebot/swashbuckle-icons/svg/ada.svg')
    case 'add-file':
      return import('@homebot/swashbuckle-icons/svg/add-file.svg')
    case 'angle-down':
      return import('@homebot/swashbuckle-icons/svg/angle-down.svg')
    case 'angle-left':
      return import('@homebot/swashbuckle-icons/svg/angle-left.svg')
    case 'angle-right':
      return import('@homebot/swashbuckle-icons/svg/angle-right.svg')
    case 'angle-up':
      return import('@homebot/swashbuckle-icons/svg/angle-up.svg')
    case 'angles-left':
      return import('@homebot/swashbuckle-icons/svg/angles-left.svg')
    case 'angles-right':
      return import('@homebot/swashbuckle-icons/svg/angles-right.svg')
    case 'arrow-left':
      return import('@homebot/swashbuckle-icons/svg/arrow-left.svg')
    case 'arrow-right':
      return import('@homebot/swashbuckle-icons/svg/arrow-right.svg')
    case 'bars':
      return import('@homebot/swashbuckle-icons/svg/bars.svg')
    case 'bathtub':
      return import('@homebot/swashbuckle-icons/svg/bathtub.svg')
    case 'bell-filled':
      return import('@homebot/swashbuckle-icons/svg/bell-filled.svg')
    case 'bell':
      return import('@homebot/swashbuckle-icons/svg/bell.svg')
    case 'bolt':
      return import('@homebot/swashbuckle-icons/svg/bolt.svg')
    case 'bot-head-circle':
      return import('@homebot/swashbuckle-icons/svg/bot-head-circle.svg')
    case 'bot-head-construction':
      return import('@homebot/swashbuckle-icons/svg/bot-head-construction.svg')
    case 'bot-head':
      return import('@homebot/swashbuckle-icons/svg/bot-head.svg')
    case 'buoy':
      return import('@homebot/swashbuckle-icons/svg/buoy.svg')
    case 'buyers-fileuploader':
      return import('@homebot/swashbuckle-icons/svg/buyers-fileuploader.svg')
    case 'buyers':
      return import('@homebot/swashbuckle-icons/svg/buyers.svg')
    case 'calculator':
      return import('@homebot/swashbuckle-icons/svg/calculator.svg')
    case 'calendar':
      return import('@homebot/swashbuckle-icons/svg/calendar.svg')
    case 'cc-amex':
      return import('@homebot/swashbuckle-icons/svg/cc-amex.svg')
    case 'cc-discover':
      return import('@homebot/swashbuckle-icons/svg/cc-discover.svg')
    case 'cc-jcb':
      return import('@homebot/swashbuckle-icons/svg/cc-jcb.svg')
    case 'cc-mastercard':
      return import('@homebot/swashbuckle-icons/svg/cc-mastercard.svg')
    case 'cc-visa':
      return import('@homebot/swashbuckle-icons/svg/cc-visa.svg')
    case 'chart-line':
      return import('@homebot/swashbuckle-icons/svg/chart-line.svg')
    case 'check-btb':
      return import('@homebot/swashbuckle-icons/svg/check-btb.svg')
    case 'check-circle-fa':
      return import('@homebot/swashbuckle-icons/svg/check-circle-fa.svg')
    case 'check-circle':
      return import('@homebot/swashbuckle-icons/svg/check-circle.svg')
    case 'check':
      return import('@homebot/swashbuckle-icons/svg/check.svg')
    case 'circle-arrow-down':
      return import('@homebot/swashbuckle-icons/svg/circle-arrow-down.svg')
    case 'circle-arrow-left':
      return import('@homebot/swashbuckle-icons/svg/circle-arrow-left.svg')
    case 'circle-arrow-right-bts':
      return import('@homebot/swashbuckle-icons/svg/circle-arrow-right-bts.svg')
    case 'circle-arrow-right':
      return import('@homebot/swashbuckle-icons/svg/circle-arrow-right.svg')
    case 'circle-arrow-up':
      return import('@homebot/swashbuckle-icons/svg/circle-arrow-up.svg')
    case 'circular-graph':
      return import('@homebot/swashbuckle-icons/svg/circular-graph.svg')
    case 'clock':
      return import('@homebot/swashbuckle-icons/svg/clock.svg')
    case 'cloud-refresh':
      return import('@homebot/swashbuckle-icons/svg/cloud-refresh.svg')
    case 'cloud-upload':
      return import('@homebot/swashbuckle-icons/svg/cloud-upload.svg')
    case 'comment-text-outline':
      return import('@homebot/swashbuckle-icons/svg/comment-text-outline.svg')
    case 'commenting-fa':
      return import('@homebot/swashbuckle-icons/svg/commenting-fa.svg')
    case 'commenting':
      return import('@homebot/swashbuckle-icons/svg/commenting.svg')
    case 'condo':
      return import('@homebot/swashbuckle-icons/svg/condo.svg')
    case 'copy':
      return import('@homebot/swashbuckle-icons/svg/copy.svg')
    case 'credit-card':
      return import('@homebot/swashbuckle-icons/svg/credit-card.svg')
    case 'database':
      return import('@homebot/swashbuckle-icons/svg/database.svg')
    case 'dm-circle':
      return import('@homebot/swashbuckle-icons/svg/dm-circle.svg')
    case 'dollar-fi':
      return import('@homebot/swashbuckle-icons/svg/dollar-fi.svg')
    case 'dollar':
      return import('@homebot/swashbuckle-icons/svg/dollar.svg')
    case 'download':
      return import('@homebot/swashbuckle-icons/svg/download.svg')
    case 'ellipsis-h':
      return import('@homebot/swashbuckle-icons/svg/ellipsis-h.svg')
    case 'ellipsis-v':
      return import('@homebot/swashbuckle-icons/svg/ellipsis-v.svg')
    case 'emergency':
      return import('@homebot/swashbuckle-icons/svg/emergency.svg')
    case 'envelope':
      return import('@homebot/swashbuckle-icons/svg/envelope.svg')
    case 'equals':
      return import('@homebot/swashbuckle-icons/svg/equals.svg')
    case 'exclamation-circle':
      return import('@homebot/swashbuckle-icons/svg/exclamation-circle.svg')
    case 'exclamation-triangle':
      return import('@homebot/swashbuckle-icons/svg/exclamation-triangle.svg')
    case 'exclamation':
      return import('@homebot/swashbuckle-icons/svg/exclamation.svg')
    case 'external-link':
      return import('@homebot/swashbuckle-icons/svg/external-link.svg')
    case 'eye-entypo':
      return import('@homebot/swashbuckle-icons/svg/eye-entypo.svg')
    case 'eye-slash':
      return import('@homebot/swashbuckle-icons/svg/eye-slash.svg')
    case 'eye':
      return import('@homebot/swashbuckle-icons/svg/eye.svg')
    case 'facebook-official':
      return import('@homebot/swashbuckle-icons/svg/facebook-official.svg')
    case 'film':
      return import('@homebot/swashbuckle-icons/svg/film.svg')
    case 'filter':
      return import('@homebot/swashbuckle-icons/svg/filter.svg')
    case 'fire':
      return import('@homebot/swashbuckle-icons/svg/fire.svg')
    case 'frown':
      return import('@homebot/swashbuckle-icons/svg/frown.svg')
    case 'fullscreenExit':
      return import('@homebot/swashbuckle-icons/svg/fullscreenExit.svg')
    case 'fullscreenOpen':
      return import('@homebot/swashbuckle-icons/svg/fullscreenOpen.svg')
    case 'gear':
      return import('@homebot/swashbuckle-icons/svg/gear.svg')
    case 'globe':
      return import('@homebot/swashbuckle-icons/svg/globe.svg')
    case 'graduation-cap':
      return import('@homebot/swashbuckle-icons/svg/graduation-cap.svg')
    case 'graph-bar':
      return import('@homebot/swashbuckle-icons/svg/graph-bar.svg')
    case 'heart-empty':
      return import('@homebot/swashbuckle-icons/svg/heart-empty.svg')
    case 'heart':
      return import('@homebot/swashbuckle-icons/svg/heart.svg')
    case 'hexagon':
      return import('@homebot/swashbuckle-icons/svg/hexagon.svg')
    case 'home-add':
      return import('@homebot/swashbuckle-icons/svg/home-add.svg')
    case 'home-fav':
      return import('@homebot/swashbuckle-icons/svg/home-fav.svg')
    case 'home':
      return import('@homebot/swashbuckle-icons/svg/home.svg')
    case 'homeimprovement':
      return import('@homebot/swashbuckle-icons/svg/homeimprovement.svg')
    case 'homeowners-fileuploader':
      return import('@homebot/swashbuckle-icons/svg/homeowners-fileuploader.svg')
    case 'homeowners':
      return import('@homebot/swashbuckle-icons/svg/homeowners.svg')
    case 'info-circle-fa':
      return import('@homebot/swashbuckle-icons/svg/info-circle-fa.svg')
    case 'info-circle':
      return import('@homebot/swashbuckle-icons/svg/info-circle.svg')
    case 'info':
      return import('@homebot/swashbuckle-icons/svg/info.svg')
    case 'laptop':
      return import('@homebot/swashbuckle-icons/svg/laptop.svg')
    case 'light-bulb':
      return import('@homebot/swashbuckle-icons/svg/light-bulb.svg')
    case 'link':
      return import('@homebot/swashbuckle-icons/svg/link.svg')
    case 'linkedin':
      return import('@homebot/swashbuckle-icons/svg/linkedin.svg')
    case 'lo':
      return import('@homebot/swashbuckle-icons/svg/lo.svg')
    case 'lock-mdc':
      return import('@homebot/swashbuckle-icons/svg/lock-mdc.svg')
    case 'lock':
      return import('@homebot/swashbuckle-icons/svg/lock.svg')
    case 'long-arrow-left':
      return import('@homebot/swashbuckle-icons/svg/long-arrow-left.svg')
    case 'long-arrow-right':
      return import('@homebot/swashbuckle-icons/svg/long-arrow-right.svg')
    case 'loop':
      return import('@homebot/swashbuckle-icons/svg/loop.svg')
    case 'magic':
      return import('@homebot/swashbuckle-icons/svg/magic.svg')
    case 'map-marked-alt':
      return import('@homebot/swashbuckle-icons/svg/map-marked-alt.svg')
    case 'map-marker-mdc':
      return import('@homebot/swashbuckle-icons/svg/map-marker-mdc.svg')
    case 'map-marker':
      return import('@homebot/swashbuckle-icons/svg/map-marker.svg')
    case 'message':
      return import('@homebot/swashbuckle-icons/svg/message.svg')
    case 'minus-btb':
      return import('@homebot/swashbuckle-icons/svg/minus-btb.svg')
    case 'minus-circle':
      return import('@homebot/swashbuckle-icons/svg/minus-circle.svg')
    case 'minus':
      return import('@homebot/swashbuckle-icons/svg/minus.svg')
    case 'mobile':
      return import('@homebot/swashbuckle-icons/svg/mobile.svg')
    case 'multiple-envelopes':
      return import('@homebot/swashbuckle-icons/svg/multiple-envelopes.svg')
    case 'no-data':
      return import('@homebot/swashbuckle-icons/svg/no-data.svg')
    case 'no-photo':
      return import('@homebot/swashbuckle-icons/svg/no-photo.svg')
    case 'paper-plane':
      return import('@homebot/swashbuckle-icons/svg/paper-plane.svg')
    case 'paused-envelope':
      return import('@homebot/swashbuckle-icons/svg/paused-envelope.svg')
    case 'pencil':
      return import('@homebot/swashbuckle-icons/svg/pencil.svg')
    case 'percent':
      return import('@homebot/swashbuckle-icons/svg/percent.svg')
    case 'phone':
      return import('@homebot/swashbuckle-icons/svg/phone.svg')
    case 'photo':
      return import('@homebot/swashbuckle-icons/svg/photo.svg')
    case 'plane':
      return import('@homebot/swashbuckle-icons/svg/plane.svg')
    case 'play-circle-outline':
      return import('@homebot/swashbuckle-icons/svg/play-circle-outline.svg')
    case 'play':
      return import('@homebot/swashbuckle-icons/svg/play.svg')
    case 'plus-btb':
      return import('@homebot/swashbuckle-icons/svg/plus-btb.svg')
    case 'plus-circle':
      return import('@homebot/swashbuckle-icons/svg/plus-circle.svg')
    case 'plus':
      return import('@homebot/swashbuckle-icons/svg/plus.svg')
    case 'pointer-click':
      return import('@homebot/swashbuckle-icons/svg/pointer-click.svg')
    case 'pricing-basic':
      return import('@homebot/swashbuckle-icons/svg/pricing-basic.svg')
    case 'pricing-enterprise':
      return import('@homebot/swashbuckle-icons/svg/pricing-enterprise.svg')
    case 'pricing-premium':
      return import('@homebot/swashbuckle-icons/svg/pricing-premium.svg')
    case 'question-circle':
      return import('@homebot/swashbuckle-icons/svg/question-circle.svg')
    case 'radio-checked':
      return import('@homebot/swashbuckle-icons/svg/radio-checked.svg')
    case 'rea':
      return import('@homebot/swashbuckle-icons/svg/rea.svg')
    case 'record-video':
      return import('@homebot/swashbuckle-icons/svg/record-video.svg')
    case 'refi':
      return import('@homebot/swashbuckle-icons/svg/refi.svg')
    case 'refresh':
      return import('@homebot/swashbuckle-icons/svg/refresh.svg')
    case 'rentalhome':
      return import('@homebot/swashbuckle-icons/svg/rentalhome.svg')
    case 'rentbuy':
      return import('@homebot/swashbuckle-icons/svg/rentbuy.svg')
    case 'rocket':
      return import('@homebot/swashbuckle-icons/svg/rocket.svg')
    case 'search-btm':
      return import('@homebot/swashbuckle-icons/svg/search-btm.svg')
    case 'search':
      return import('@homebot/swashbuckle-icons/svg/search.svg')
    case 'selling':
      return import('@homebot/swashbuckle-icons/svg/selling.svg')
    case 'sellpocket':
      return import('@homebot/swashbuckle-icons/svg/sellpocket.svg')
    case 'share-arrow':
      return import('@homebot/swashbuckle-icons/svg/share-arrow.svg')
    case 'shower':
      return import('@homebot/swashbuckle-icons/svg/shower.svg')
    case 'single-user':
      return import('@homebot/swashbuckle-icons/svg/single-user.svg')
    case 'sink':
      return import('@homebot/swashbuckle-icons/svg/sink.svg')
    case 'solar':
      return import('@homebot/swashbuckle-icons/svg/solar.svg')
    case 'spinner-clock':
      return import('@homebot/swashbuckle-icons/svg/spinner-clock.svg')
    case 'star-bts':
      return import('@homebot/swashbuckle-icons/svg/star-bts.svg')
    case 'star':
      return import('@homebot/swashbuckle-icons/svg/star.svg')
    case 'thumbs-down':
      return import('@homebot/swashbuckle-icons/svg/thumbs-down.svg')
    case 'thumbs-up':
      return import('@homebot/swashbuckle-icons/svg/thumbs-up.svg')
    case 'tilde':
      return import('@homebot/swashbuckle-icons/svg/tilde.svg')
    case 'times-btb':
      return import('@homebot/swashbuckle-icons/svg/times-btb.svg')
    case 'times-circle':
      return import('@homebot/swashbuckle-icons/svg/times-circle.svg')
    case 'times':
      return import('@homebot/swashbuckle-icons/svg/times.svg')
    case 'toilet':
      return import('@homebot/swashbuckle-icons/svg/toilet.svg')
    case 'torso-business':
      return import('@homebot/swashbuckle-icons/svg/torso-business.svg')
    case 'tradeup':
      return import('@homebot/swashbuckle-icons/svg/tradeup.svg')
    case 'trash':
      return import('@homebot/swashbuckle-icons/svg/trash.svg')
    case 'triangle-down':
      return import('@homebot/swashbuckle-icons/svg/triangle-down.svg')
    case 'triangle-up':
      return import('@homebot/swashbuckle-icons/svg/triangle-up.svg')
    case 'truck':
      return import('@homebot/swashbuckle-icons/svg/truck.svg')
    case 'two-envelopes':
      return import('@homebot/swashbuckle-icons/svg/two-envelopes.svg')
    case 'upload':
      return import('@homebot/swashbuckle-icons/svg/upload.svg')
    case 'users':
      return import('@homebot/swashbuckle-icons/svg/users.svg')
    case 'video-camera':
      return import('@homebot/swashbuckle-icons/svg/video-camera.svg')
    case 'wallet-entypo':
      return import('@homebot/swashbuckle-icons/svg/wallet-entypo.svg')
    case 'wallet':
      return import('@homebot/swashbuckle-icons/svg/wallet.svg')
    case 'wand':
      return import('@homebot/swashbuckle-icons/svg/wand.svg')
    case 'wrench-filled':
      return import('@homebot/swashbuckle-icons/svg/wrench-filled.svg')
    case 'wrench':
      return import('@homebot/swashbuckle-icons/svg/wrench.svg')
    default:
      return new Promise(function(resolve, reject) { 
        reject.bind(null, new Error('Tried to dynamically import unknown icon: ' + iconName))
      })
  }
}

export const AVAILABLE_ICONS = [
  'ada',
  'add-file',
  'angle-down',
  'angle-left',
  'angle-right',
  'angle-up',
  'angles-left',
  'angles-right',
  'arrow-left',
  'arrow-right',
  'bars',
  'bathtub',
  'bell-filled',
  'bell',
  'bolt',
  'bot-head-circle',
  'bot-head-construction',
  'bot-head',
  'buoy',
  'buyers-fileuploader',
  'buyers',
  'calculator',
  'calendar',
  'cc-amex',
  'cc-discover',
  'cc-jcb',
  'cc-mastercard',
  'cc-visa',
  'chart-line',
  'check-btb',
  'check-circle-fa',
  'check-circle',
  'check',
  'circle-arrow-down',
  'circle-arrow-left',
  'circle-arrow-right-bts',
  'circle-arrow-right',
  'circle-arrow-up',
  'circular-graph',
  'clock',
  'cloud-refresh',
  'cloud-upload',
  'comment-text-outline',
  'commenting-fa',
  'commenting',
  'condo',
  'copy',
  'credit-card',
  'database',
  'dm-circle',
  'dollar-fi',
  'dollar',
  'download',
  'ellipsis-h',
  'ellipsis-v',
  'emergency',
  'envelope',
  'equals',
  'exclamation-circle',
  'exclamation-triangle',
  'exclamation',
  'external-link',
  'eye-entypo',
  'eye-slash',
  'eye',
  'facebook-official',
  'film',
  'filter',
  'fire',
  'frown',
  'fullscreenExit',
  'fullscreenOpen',
  'gear',
  'globe',
  'graduation-cap',
  'graph-bar',
  'heart-empty',
  'heart',
  'hexagon',
  'home-add',
  'home-fav',
  'home',
  'homeimprovement',
  'homeowners-fileuploader',
  'homeowners',
  'info-circle-fa',
  'info-circle',
  'info',
  'laptop',
  'light-bulb',
  'link',
  'linkedin',
  'lo',
  'lock-mdc',
  'lock',
  'long-arrow-left',
  'long-arrow-right',
  'loop',
  'magic',
  'map-marked-alt',
  'map-marker-mdc',
  'map-marker',
  'message',
  'minus-btb',
  'minus-circle',
  'minus',
  'mobile',
  'multiple-envelopes',
  'no-data',
  'no-photo',
  'paper-plane',
  'paused-envelope',
  'pencil',
  'percent',
  'phone',
  'photo',
  'plane',
  'play-circle-outline',
  'play',
  'plus-btb',
  'plus-circle',
  'plus',
  'pointer-click',
  'pricing-basic',
  'pricing-enterprise',
  'pricing-premium',
  'question-circle',
  'radio-checked',
  'rea',
  'record-video',
  'refi',
  'refresh',
  'rentalhome',
  'rentbuy',
  'rocket',
  'search-btm',
  'search',
  'selling',
  'sellpocket',
  'share-arrow',
  'shower',
  'single-user',
  'sink',
  'solar',
  'spinner-clock',
  'star-bts',
  'star',
  'thumbs-down',
  'thumbs-up',
  'tilde',
  'times-btb',
  'times-circle',
  'times',
  'toilet',
  'torso-business',
  'tradeup',
  'trash',
  'triangle-down',
  'triangle-up',
  'truck',
  'two-envelopes',
  'upload',
  'users',
  'video-camera',
  'wallet-entypo',
  'wallet',
  'wand',
  'wrench-filled',
  'wrench'
]